import { ISelectData } from '../ui/Selects/select/model'

export const createSingleSelectData = (label: string, id: number): ISelectData => {
  return {
    label: id + '. ' + label,
    value: id
  }
}
